import { isDeviceMobile } from '../../../../helpers/helpers';

export default function TextArea({
  label,
  fieldName,
  value,
  onInputChange,
  config,
  removeFromList = null,
}) {
  return (
    <div className="mb-3  w-100 d-flex flex-column">
      <label htmlFor={fieldName} className="form-label">
        {label}
      </label>

      <textarea
        id={fieldName}
        value={value}
        onChange={onInputChange}
        name={fieldName}
        className="form-control paragraph_text_field"
      />

      {removeFromList && (
        <>
          {/* Desktop version */}
          {!isDeviceMobile() && config.lang === 'ar' && (
            <button
              type="button"
              className="btn btn-danger my-4 remove_button_height custom_button_desktop"
              onClick={removeFromList}
            >
              Remove
            </button>
          )}

          {!isDeviceMobile() && config.lang !== 'ar' && (
            <div className="remove_button_height my-4" />
          )}

          {/* Mobile version */}
          {isDeviceMobile() && (
            <button
              type="button"
              className="btn btn-danger my-4 remove_button_height w-content"
              onClick={removeFromList}
            >
              {config.lang === 'ar' ? 'حذف' : 'Remove'}
            </button>
          )}
        </>
      )}

      {/* 
      {removeFromList && !isDeviceMobile() && config.lang == 'en' && (
        <div className="remove_button_height my-4" />
      )} */}
    </div>
  );
}
